(function () {
  // Rotate SquareLocator arrow marks so they point at the mouse cursor.
  // arrow-down.svg is the corner mark: its tip points to the bottom-left
  // corner, i.e. 135deg in screen coordinates.
  const BASE_ANGLE = 135;
  const arrows = [];
  let listening = false;

  const render = (entry) => {
    const diff = entry.target - entry.current;
    entry.current += diff * 0.12;
    entry.el.style.transform = `rotate(${entry.current}deg)`;

    if (Math.abs(diff) > 0.05) {
      entry.rafId = requestAnimationFrame(() => render(entry));
    } else {
      entry.rafId = null;
    }
  };

  const onMouseMove = (event) => {
    for (const entry of arrows) {
      // Skip arrows hidden at the current breakpoint.
      if (!entry.el.offsetParent) continue;

      const rect = entry.el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      const angle =
        (Math.atan2(event.clientY - cy, event.clientX - cx) * 180) / Math.PI;

      let next = angle - BASE_ANGLE;

      // Take the shortest rotation path so the arrow never spins the long way.
      while (next - entry.current > 180) next -= 360;
      while (next - entry.current < -180) next += 360;

      entry.target = next;
      if (entry.rafId === null) {
        entry.rafId = requestAnimationFrame(() => render(entry));
      }
    }
  };

  const initArrows = (root = document) => {
    root.querySelectorAll(".js-arrow-pointer").forEach((el) => {
      if (el.dataset.pointerInit === "true") return;
      el.dataset.pointerInit = "true";
      arrows.push({ el, target: 0, current: 0, rafId: null });
    });

    if (arrows.length && !listening) {
      listening = true;
      document.addEventListener("mousemove", onMouseMove, { passive: true });
    }
  };

  initArrows();

  document.addEventListener("shopify:section:load", (event) => {
    initArrows(event.target);
  });
})();
